import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Input,
  Card,
  CardBody,
  Label,
  Button,
  InputGroup,
} from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch, useSelector } from 'react-redux';
import * as organizarActions from '../store/organizar.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import * as commonActions from '@common/common.action';
import { Switch, FormControlLabel } from '@material-ui/core';
import DragDropApi from '../../dragdrop.api';
import UteisHistologia from '../../../../pages/histologia/laminas/laminas.util';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import IntlMessage from "../../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Histologia(props) {
  const [destino, setDestino] = useState();
  const [destinos, setDestinos] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [identificacao, setIdentificacao] = useState();
  const [isAutoInput, setIsAutoInput] = useState(false);
  const [selectTipo, setSelectTipo] = useState();
  const [nextTipo, setNextTipo] = useState();
  const [showModal, setShowModal] = useState();
  const [isLaminas, setIsLaminas] = useState();
  const [dados, setDados] = useState();
  const organizarLote = useSelector((state) => state.organizarLote);
  const dispatch = useDispatch();
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

  const componentRef = useRef();

  const tipos = [
    { label: <IntlMessage id="general.materialArchiving.blocks" />, value: 1 },
    { label: <IntlMessage id="general.materialArchiving.blades" />, value: 2 },
  ];

  useEffect(() => {
    reset();
  }, []);

  useEffect(() => {
    const disabled = !selectGrid || !destino;
    dispatch(organizarActions.atualizarMoverDisabled(disabled));
  }, [selectGrid, destino]);

  useEffect(() => {
    function montarColunas(list) {
      let colunas = [];
      // eslint-disable-next-line array-callback-return
      list.map((item) => {
        colunas.push({
          label: item.title.text,
          value: Object.keys(item)[0],
        });
      });
      if (
        Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
        colunas.findIndex((x) => x.value === quadroKanbanEnum.HL_BLOCOS.id) >= 0
      ) {
        const ndestinos = [...colunas];
        colunas.find(
          (x, i) =>
            x.value === quadroKanbanEnum.HL_BLOCOS.id && delete ndestinos[i]
        );
        setDestinos(ndestinos);
      } else {
        setDestinos(colunas);
      }
    }
    montarColunas(props.lista);
  }, [props.lista]);

  useEffect(() => {
    if (props.click) {
      dispatch(commonActions.showFadeCarregando(true));
      moverItens();
    }
  }, [props.click]);

  useEffect(() => {
    if (organizarLote.laminas.length > 0 && dados && dados.length > 0) {
      insertSelect(dados);
    }
  }, [dados]);

  function reset() {
    dispatch(organizarActions.atualizarLamina([]));
    dispatch(organizarActions.atualizarMoverDisabled(true));
    dispatch(organizarActions.atualizarLista([]));
    setSelectGrid(0);
    setDestino();
    setSelectTipo({ label: <IntlMessage id="general.materialArchiving.block" />, value: 1 });
    if (Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id) {
      setIsLaminas(true);
    } else {
      setIsLaminas(false);
    }
  }

  useEffect(() => {
    componentRef.current && componentRef.current.focus();
  });

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.data.itemId.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
  }

  function toggleCheckBox(checked) {
    let checkboxes = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document
          .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
          .getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function removerItem(id) {
    let draft = organizarLote.lista;
    let index = draft.findIndex((x) => x.id === id);
    draft.splice(index, 1);
    dispatch(organizarActions.atualizarLista(draft));
  }

  function insertSelect(dados) {
    let item = dados[0];
    const novaLista = {
      id: item.id,
      itemId: item.id,
      exame: item.nrBloco ? item.nrBloco : item.nrLamina,
      //tipo: item.nrBloco ? 'BLOCO' : 'LÂMINA',
      tipo: item.tipoBloco ? item.tipoBloco : item.tipoLamina,
      nomeTecnico: item.nomeTecnico,
      qtdLamina:
        organizarLote.laminas.length > 0 ? (
          <div className="qtd-laminas-group">
            <input
              className="qtd-laminas-button-remove float-left"
              id={`remove-laminas-${item.id}`}
              type="button"
              value="-"
              onClick={() => removeLamina(item.id)}
            />

            <input
              className="qtd-laminas-button"
              id={`input-laminas-${item.id}`}
              style={{ width: '40px' }}
              type="number"
              defaultValue="1"
              onChange={(ev) => chanceLamina(item.id, ev.target.value)}
            />
            <input
              className="qtd-laminas-button-add float-left"
              id={`add-laminas-${item.id}`}
              value="+"
              type="button"
              onClick={() => addLamina(item.id)}
            />
          </div>
        ) : (
          ''
        ),

      remove: (
        <Button onClick={() => removerItem(item.id)}>
          <i className="mv-basico-apagar"></i>
        </Button>
      ),
      select: (
        <input
          className="checkbox"
          name="checkbox"
          type="checkbox"
          id={item.id}
          onClick={(e) => selectItem(e)}
        />
      ),
    };

    let draft = organizarLote.lista;
    if (draft.length > 0) {
      const found = draft.some(
        (element) => novaLista.itemId === element.itemId
      );
      if (found) {
        dispatch(commonActions.showFadeCarregando(false));
        return dispatch(
          commonActions.showAlerta(
            'alerta',
            <IntlMessage id="dashboards.sample.thisItemHasAdded" />,
            3000
          )
        );
      } else {
        draft.push(novaLista);
      }
      // setLista(draft);
      dispatch(organizarActions.atualizarLista(draft));
    } else {
      draft.push(novaLista);
      // setLista(draft);
      dispatch(organizarActions.atualizarLista(draft));
    }
    dispatch(commonActions.showFadeCarregando(false));
    componentRef.current.focus();
  }

  function getIconeStatus(value) {
    let icone, status;

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
      value === quadroKanbanEnum.HL_PENDENTES.id
    ) {
      icone = quadroKanbanEnum.HL_PENDENTES.icone;
      status = quadroKanbanEnum.HL_PENDENTES.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
      value === quadroKanbanEnum.HL_EXECUTANDO.id
    ) {
      icone = quadroKanbanEnum.HL_EXECUTANDO.icone;
      status = quadroKanbanEnum.HL_EXECUTANDO.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
      value === quadroKanbanEnum.HL_PRONTAS.id
    ) {
      icone = quadroKanbanEnum.HL_PRONTAS.id;
      status = quadroKanbanEnum.HL_PRONTAS.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
      value === quadroKanbanEnum.HI_CASSETE.id
    ) {
      icone = quadroKanbanEnum.HI_CASSETE.icone;
      status = quadroKanbanEnum.HI_CASSETE.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
      value === quadroKanbanEnum.HI_EXECUTANDO.id
    ) {
      icone = quadroKanbanEnum.HI_EXECUTANDO.icone;
      status = quadroKanbanEnum.HI_EXECUTANDO.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
      value === quadroKanbanEnum.HI_BLOCOS.id
    ) {
      icone = quadroKanbanEnum.HI_BLOCOS.icone;
      status = quadroKanbanEnum.HI_BLOCOS.status;
    }
    return { icone, status };
  }

  function montarLaminas(itens) {
    let laminas = [];
    for (let i = 0; i < itens.length; i++) {
      // eslint-disable-next-line array-callback-return
      organizarLote.lista.find((l) => {
        if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
          const iconeStatus = getIconeStatus(destino.value);
          laminas.push({
            cdAnticorpo: 0,
            lamina: l.itemId,
            status: iconeStatus.status,
          });
        }
      });
    }
    return laminas;
  }

  function montarCassete(itens) {
    let cassetes = [];
    //const id = Object.keys(props.data)[0];
    for (let i = 0; i < itens.length; i++) {
      // eslint-disable-next-line array-callback-return
      organizarLote.lista.find((l) => {
        if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
          //const item = props.data[id].find((x) => x.id === l.itemId);
          const iconeStatus = getIconeStatus(destino.value);
          cassetes.push({
            laudoBloco: l.itemId,
            status: iconeStatus.status,
          });
        }
      });
    }
    return cassetes;
  }

  function montarLoteLaminas(itens) {
    //kanbanState.laminas
    let lote = [];

    for (let i = 0; i < itens.length; i++) {
      // eslint-disable-next-line array-callback-return
      organizarLote.lista.find((l) => {
        if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
          const item = dados.find((x) => x.id === l.itemId);
          const iconeStatus = getIconeStatus(destino.value);
          lote.push({
            nrBloco: item.nrBloco,
            blocoID: item.id,
            laudoID: item.cdLaudo,
            medicoID: 0,
            tecnicoID: item.idTecnico,
            sentinelaMama: item.sentinelaMama,
            sentinelaMelanoma: item.sentinelaMelanoma,
            complemento: null,
            lamina: UteisHistologia.getTipoLamina(item.tipoBloco, intl).nome,
            qtd: organizarLote.laminas.find((x) => x.exame === item.nrBloco)
              .value,
            cdAnticorpo: 0,
            destino: 'NAO_INFORMADO',
            status: iconeStatus.status,
          });
        }
      });
    }

    return lote;
  }

  async function moverItens() {
    dispatch(commonActions.showFadeCarregando(true));
    const data = document
      .getElementsByClassName('kanban-histologia-organizar-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    const id = Object.keys(props.data)[0];
    const source = {
      droppableId: id,
      index: props.lista.findIndex((x) => Object.keys(x)[0] === id),
      ...getIconeStatus(id),
    };

    const destination = {
      droppableId: destino.value,
      index: props.lista.findIndex((x) => Object.keys(x)[0] === destino.value),
      ...getIconeStatus(destino.value),
    };

    if (organizarLote.laminas.length > 0) {
      //Histologia Lâmina (BLOCOS -> Laminas)
      const payload = montarLoteLaminas(data, source, destination);
      const lote = { laminas: payload };

      const sendBlocos = await DragDropApi.criarLaminas(lote);
      if (sendBlocos.success) {
        dispatch(
          commonActions.showAlerta(
            'sucesso',
            <IntlMessage id="dashboards.sample.bladesCreatedSuccessfully" />,
            2000
          )
        );
        dispatch(organizarActions.atualizarNovasLaminas(sendBlocos.success));
      }
    } else {
      // Histologia Inclusão
      if (Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id) {
        const payload = montarCassete(data, source, destination);
        const cassetes = { cassetes: payload };
        const sendInclusao = await DragDropApi.moverCassetes(cassetes);
        if (sendInclusao.success) {
          dispatch(
            commonActions.showAlerta(
              'sucesso',
              <IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
              2000
            )
          );
          dispatch(
            organizarActions.atualizarNovasLaminas(sendInclusao.success)
          );
        }
        // Histologia Lâmina
      } else if (
        Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id
      ) {
        const payload = montarLaminas(data, source, destination);
        const laminas = { laminas: payload };
        const sendLaminas = await DragDropApi.moverLaminas(laminas);

        if (sendLaminas.success) {
          dispatch(
            commonActions.showAlerta(
              'sucesso',
              <IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
              2000
            )
          );
          dispatch(organizarActions.atualizarNovasLaminas(sendLaminas.success));
        }
      }
    }
    dispatch(commonActions.showFadeCarregando(false));
    return dispatch(organizarActions.atualizarModal(false));
  }

  function chanceLamina(id, val) {
    const nlaminas = [...organizarLote.laminas];
    const btnRemover = document.getElementById(`remove-laminas-${id}`);
    const el = document.getElementById(`input-laminas-${id}`);
    const value = val.toString();
    // eslint-disable-next-line array-callback-return
    organizarLote.laminas.find((item, index) => {
      if (item.id === id) {
        el.value = value;
        nlaminas[index].value = value;
      }
      if (value < 2) {
        document.getElementById(`input-laminas-${id}`).value = 1;
        btnRemover.disabled = true;
      } else {
        btnRemover.disabled = false;
      }
    });
    return (
      nlaminas.length > 0 &&
      dispatch(organizarActions.atualizarLamina(nlaminas))
    );
  }

  function addLamina(id) {
    let value =
      Number(document.getElementById(`input-laminas-${id}`).value) + 1;
    const btnRemover = document.getElementById(`remove-laminas-${id}`);
    if (value < 2) {
      document.getElementById(`input-laminas-${id}`).value = 1;
      btnRemover.disabled = true;
    } else {
      btnRemover.disabled = false;
    }
    chanceLamina(id, value);
  }

  function removeLamina(id) {
    let value =
      Number(document.getElementById(`input-laminas-${id}`).value) - 1;
    const btnRemover = document.getElementById(`remove-laminas-${id}`);
    if (value < 2) {
      value = 1;
      btnRemover.disabled = true;
    } else {
      btnRemover.disabled = false;
    }
    chanceLamina(id, value);
  }

  async function carregarQtdLaminas(dados) {
    const tempLaminas = [];
    // eslint-disable-next-line array-callback-return
    dados.map((item) => {
      tempLaminas.push({
        id: item.id,
        value: '1',
        exame: item.nrBloco ? item.nrBloco : item.nrLamina,
      });
    });
    dispatch(organizarActions.atualizarLamina(tempLaminas));
  }

  function changeAutoInput(e) {
    setIsAutoInput(e);
    setTimeout(() => {
      componentRef.current.focus();
    }, 600);
    setIdentificacao('');
  }

  function adicionarItem() {
    if (!identificacao) return;

    dispatch(commonActions.showFadeCarregando(true));
    if (selectTipo && selectTipo.value === 1) {
      identificacao &&
        DragDropApi.getCassetes(identificacao).then((res) => {
          if (isLaminas) {
            carregarQtdLaminas([res.data]);
            setDados([res.data]);
          } else {
            insertSelect([res.data]);
          }
          dispatch(commonActions.showFadeCarregando(false));
        });
    } else {
      identificacao &&
        DragDropApi.getLaminasHisto(identificacao).then((res) => {
          insertSelect([res.data]);
        });
    }

    setIdentificacao('');
  }

  function changeIdentificacao(e) {
    if (isAutoInput) {
      dispatch(commonActions.showFadeCarregando(true));
      if (e && e.length > 3) {
        if (selectTipo && selectTipo.value === 1) {
          DragDropApi.getCassetes(e).then((res) => {
            if (isLaminas) {
              carregarQtdLaminas([res.data]);
              setDados([res.data]);
            } else {
              insertSelect([res.data]);
            }
          });
        } else {
          DragDropApi.getLaminasHisto(e).then((res) => {
            insertSelect([res.data]);
          });
        }
      }
      e && e.length > 3 ? setIdentificacao('') : setIdentificacao(e);
      componentRef.current.focus();
    } else {
      setIdentificacao(e);
    }
  }

  function changeDestino(e) {
    setDestino(e);
  }

  function changeTipo(e) {
    if (organizarLote.lista.length > 0) {
      setNextTipo(e);
      setShowModal(true);
    } else {
      setSelectTipo(e);
    }
  }
  function modalConfirmarClick() {
    reset();
    setSelectTipo(nextTipo);
    setShowModal(false);
  }

  return (
    <React.Fragment>
      <ModalConfirmar
        toggleModalConfirmar={() => setShowModal(!showModal)}
        showModalConfirmar={showModal}
        titulo={<IntlMessage id="dashboards.sample.changeTheType" />}
        mensagem={<IntlMessage id="dashboards.sample.tableDataErased" />}
        confirmar={(e) => modalConfirmarClick(e)}
      />
      <Card>
        <CardBody>
          <Row>
            <div className="col-3" style={{ marginRight: 0 }}>
              <InputGroup>
                <Input
                  innerRef={componentRef}
                  style={{
                    borderRadius: '5px',
                    fontSize: '13px',
                  }}
                  value={identificacao}
                  placeholder={`${intl.formatMessage({id: 'dashboards.cytology.identificationNumber'})}`}
                  onChange={(e) => changeIdentificacao(e.target.value)}
                />
                <Button
                  className="btn btn-primary"
                  style={{ height: '38px', float: 'left' }}
                  disabled={isAutoInput}
                  onClick={() => adicionarItem()}
                >
                  <i className="icons-btn mv-basico-adicionar"></i>
                </Button>
              </InputGroup>
            </div>

            {isLaminas && (
              <div className="col-3">
                <Label
                  className="label-data col-auto"
                  style={{ float: 'left' }}
                >
                  <IntlMessage id="general.materialArchiving.type" />:
                </Label>
                <SelectComponent
                  onChange={(e) => changeTipo(e)}
                  className="col-auto"
                  defaultValue={selectTipo}
                  value={selectTipo}
                  options={tipos}
                  placeholder={`${intl.formatMessage({id: 'dashboards.taskControl.type'})}`}
                />
              </div>
            )}

            <div className="col-4">
              <Label className="label-data col-auto" style={{ float: 'left' }}>
                <IntlMessage id="dashboards.cytology.destiny" />
              </Label>
              <SelectComponent
                onChange={(e) => changeDestino(e)}
                className="col-auto"
                value={destino}
                options={destinos}
                placeholder={translate("dashboards.cytology.selectDestiny")}
              />
            </div>

            <div>
              <FormControlLabel
                control={
                  <Switch
                    checked={isAutoInput}
                    onChange={(e) => changeAutoInput(e.target.checked)}
                    name="auto-input"
                    color="primary"
                  />
                }
                label={<IntlMessage id="dashboards.histology.autoInput" />}
              />
            </div>
          </Row>
          <br />
          <DataTable
            className="kanban-histologia-organizar-modal-table"
            onContextMenu={(e) => onChangeSelect(e)}
            value={organizarLote.lista}
            //pageLinkSize={20}
            responsive={true}
            selectionMode="single"
            style={{ height: '100%' }}
            columnResizeMode="expand"
            scrollable={true}
            //scrollHeight="50vh"
            scrollWidth="100%"
            //resizableColumns={listaDetalhes.length >= 1}
            //reorderableColumns={listaDetalhes.length >= 1}
            //rowsPerPageOptions={[10, 20, 50]}
            //rows={totalItensPage}
            lazy={true}
            paginator={false}
            //loading={carregando}
            //loadingIcon="mv-basico-menu_secundario"
            emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
          //footer={<RenderizarFooter total={totalItens} />}
          >
            <Column
              sortable={false}
              field="select"
              style={{ width: '25px', verticalAlign: 'middle' }}
              header={
                organizarLote.lista.length >= 1 && (
                  <input
                    type="checkbox"
                    id="selectMaterias"
                    name="selectMaterias"
                    onChange={(e) => {
                      toggleCheckBox(e.target.checked);
                    }}
                  />
                )
              }
            />

            <Column
              sortable={false}
              field="exame"
              style={{
                width: '150px',
                verticalAlign: 'middle',
              }}
              header={<IntlMessage id="general.materialArchiving.identification" />}
            />

            <Column
              sortable={false}
              field="tipo"
              style={{ width: '150px', verticalAlign: 'middle' }}
              header={`${intl.formatMessage({id: 'general.materialArchiving.type'})} ${intl.formatMessage({id: 'general.materialArchiving.material'})}`}
            />

            <Column
              sortable={false}
              field="nomeTecnico"
              style={{ width: '180px', verticalAlign: 'middle' }}
              header={<IntlMessage id="dashboards.sample.technicianName" />}
            />

            <Column
              style={
                !organizarLote.laminas.length > 0
                  ? { display: 'none' }
                  : {
                    width: '120px',
                    verticalAlign: 'middle',
                  }
              }
              sortable={false}
              field="qtdLamina"
              header={<IntlMessage id="dashboards.examDetails.blade" />}
            />

            <Column
              style={{ width: 'auto', verticalAlign: 'middle' }}
              sortable={false}
              field="remove"
              header={<IntlMessage id="general.materialArchiving.remove" />}
            />
          </DataTable>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/containers/histologia.js